import React from 'react'
import PropTypes from 'prop-types'

import { Toggle as ToggleComponent } from '..'

const ToggleFormAdapterComponent = ({ input }) => {
  return <ToggleComponent toggled={input.value} onChange={input.onChange} />
}

ToggleFormAdapterComponent.propTypes = {
  input: PropTypes.object,
}

export default ToggleFormAdapterComponent
